
import { useState } from 'react';
import { useLocation } from 'react-router-dom';

export const useSidebarState = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [rentalSubmenuOpen, setRentalSubmenuOpen] = useState(
    currentPath.includes('/rental-') || currentPath.includes('/cross-location')
  );

  const isRentalActive = currentPath.includes('/rental-') || currentPath.includes('/cross-location');
  
  const toggleRentalSubmenu = () => {
    setRentalSubmenuOpen(!rentalSubmenuOpen);
  };

  return {
    currentPath,
    rentalSubmenuOpen,
    isRentalActive,
    toggleRentalSubmenu
  };
};
